import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import contractData from '../contracts/SmallClaimsCaseRegistry.json';

const RoleStatus = ({ address }) => {
  const [hasRole, setHasRole] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [error, setError] = useState(null);
  const [roleHash, setRoleHash] = useState('');

  useEffect(() => {
    const checkRole = async () => {
      if (!address) return;
      
      setIsChecking(true);
      setError(null);
      
      try {
        // Get the role hash
        const registrarRoleHash = contractData.roles["REGISTRAR_ROLE"];
        setRoleHash(registrarRoleHash);
        
        // Method 1: Check if the address is in the registrars list from contract data
        const isInRegistrarsList = contractData.registrars.some(
          registrar => registrar.toLowerCase() === address.toLowerCase()
        );
        
        console.log(`Checking if ${address} is in registrars list:`, isInRegistrarsList);
        
        // Method 2: Try to check using contract call
        let contractCallResult = false;
        
        if (window.ethereum) {
          try {
            const provider = new ethers.BrowserProvider(window.ethereum);
            
            // Create contract instance directly for reliable checking
            const contract = new ethers.Contract(
              contractData.address,
              contractData.abi,
              provider
            );
            
            // Convert address to checksum format for consistency
            const checksumAddress = ethers.getAddress(address);
            
            // Call hasRole directly on contract - use a safe method that won't throw
            try {
              // Use call() method to avoid exceptions on reverts
              contractCallResult = await contract.hasRole.staticCall(registrarRoleHash, checksumAddress);
              console.log(`Contract hasRole result for ${checksumAddress}:`, contractCallResult);
            } catch (staticCallErr) {
              console.warn("Static call failed, falling back to regular call:", staticCallErr);
              // Regular call as a fallback
              contractCallResult = await contract.hasRole(registrarRoleHash, checksumAddress);
              console.log(`Regular call hasRole result for ${checksumAddress}:`, contractCallResult);
            }
          } catch (contractErr) {
            console.warn("Could not verify role via contract call:", contractErr);
            console.log("Falling back to registrars list for permission check");
            // Continue with the registrars list result if contract call fails
          }
        }
        
        // Use either the contract call result or the registrars list check
        setHasRole(contractCallResult || isInRegistrarsList);
        
      } catch (err) {
        console.error("Error checking role status:", err);
        setError(err.message);
      } finally {
        setIsChecking(false);
      }
    };
    
    checkRole();
  }, [address]);
  
  const renderContent = () => {
    if (isChecking) {
      return <div>Checking REGISTRAR_ROLE status...</div>;
    }
    
    if (error) {
      return <div style={{ color: '#e53e3e' }}>Error checking role: {error}</div>;
    }
    
    if (hasRole) {
      // Check if the address is in the official registrars list
      const isInList = contractData.registrars.some(
        registrar => registrar.toLowerCase() === address.toLowerCase()
      );
      
      return (
        <div style={{ padding: '15px', backgroundColor: '#dcfce7', borderRadius: '4px', marginTop: '10px' }}>
          <div style={{ fontWeight: 'bold', color: '#166534' }}>
            <span style={{ marginRight: '8px' }}>✅</span>
            REGISTRAR_ROLE Active
          </div>
          <p style={{ margin: '8px 0 0 0', color: '#166534' }}>
            Your account is authorized to register cases on the blockchain.
          </p>
          <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#166534' }}>
            {isInList 
              ? "Your address is in the pre-approved registrars list." 
              : "Your address has been granted the REGISTRAR_ROLE after deployment."}
          </p>
        </div>
      );
    } else {
      return (
        <div style={{ padding: '15px', backgroundColor: '#fee2e2', borderRadius: '4px', marginTop: '10px' }}>
          <div style={{ fontWeight: 'bold', color: '#b91c1c' }}>
            <span style={{ marginRight: '8px' }}>❌</span>
            REGISTRAR_ROLE Missing
          </div>
          <p style={{ margin: '8px 0 0 0', color: '#b91c1c' }}>
            Your account does not have permission to register cases.
          </p>
          <p style={{ margin: '8px 0 0 0', color: '#b91c1c' }}>
            Please contact the system administrator to request access.
          </p>
        </div>
      );
    }
  };
  
  return (
    <div>
      <div style={{ marginBottom: '5px' }}>
        <strong>Address:</strong> {address}
      </div>
      <div style={{ marginBottom: '10px', fontSize: '12px', color: '#6b7280' }}>
        <strong>Role Hash:</strong> {roleHash}
      </div>
      {renderContent()}
    </div>
  );
};

export default RoleStatus;